import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import ReduxToastr from "react-redux-toastr";
import store from "../store";

const persistor = persistStore(store);

export default function ReactReduxProvider({ children }) {
    return (
        <Provider store={store}>
            <ReduxToastr
                position="top-center"
                transitionIn="bounceIn"
                transitionOut="bounceOut"
                progressBar
                preventDuplicates={true}
            />
            <PersistGate persistor={persistor}>{children}</PersistGate>
        </Provider>
    );
}
